export default function OverviewSection() {
  return (
    <section id="overview" className="overview-section">
      <div className="overview-inner">
        <div>
          <div className="eyebrow-label">Who We Are</div>
          <h2>
            A Holding Company Built for the{' '}
            <span>Digital Asset Era</span>
          </h2>
          <div className="overview-text">
            <p>
              Apex DeFi Labs Inc. is a New York-based technology holding company founding, funding, and operating businesses at the convergence of{' '}
              <strong>blockchain infrastructure, AI-powered compliance, and regulated capital markets</strong>.
            </p>
            <p>
              Through our subsidiaries and brand ventures, we are building the enterprise software layer that issuers, broker-dealers, RIAs, attorneys, and CPAs will use to participate in the tokenized securities economy — a market BCG projects will reach{' '}
              <strong>$16 trillion by 2030</strong>.
            </p>
          </div>
          <div className="overview-tags">
            <span className="otag">Tokenized Securities</span>
            <span className="otag">AI Compliance</span>
            <span className="otag">Reg D · Reg A+ · Reg CF</span>
            <span className="otag">ERC-1400</span>
            <span className="otag">Web3 Infrastructure</span>
            <span className="otag">HealthTech</span>
          </div>
        </div>

        <div className="overview-stats">
          <div className="os"><div className="os-val">3</div><div className="os-label">Subsidiaries</div></div>
          <div className="os"><div className="os-val">4</div><div className="os-label">Brand Ventures</div></div>
          <div className="os"><div className="os-val">21</div><div className="os-label">VYASA Products</div></div>
          <div className="os"><div className="os-val">5</div><div className="os-label">SEC Frameworks</div></div>
        </div>
      </div>
    </section>
  );
}
